// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3SySe","item":"PaymentsMobile_item__3B1lo","label":"PaymentsMobile_label__1Ydl2","amount":"PaymentsMobile_amount__1HpHc"};